/**
  There are v8 reasons for initializing the state with this:
  the state POJO will maintain the same internal hidden class
  when updated with updateIfNeeded.
*/
export const initializeRecord: <S extends Record<any, any>>(state: S) => S = (
  state
) => {
  return Object.assign({}, state);
};

/**
  If there are differences in `mergeObject` (checked shallowly with ===),
  clone and return new state with same shape (and internal v8 hidden class).
*/
export const updateIfNeeded: <S extends Record<any, any>>(
  state: S,
  mergeObject: Partial<S>
) => S = (state, mergeObject) => {
  // Short-circuit if any value in mergeObject is different
  for (const key in mergeObject) {
    if (state[key] !== mergeObject[key]) {
      return Object.assign({}, state, mergeObject);
    }
  }
  // No changes in mergeObject
  return state;
};

/**
  If the value is different (checked with ===), clone and return new state
  with same shape (and internal v8 hidden class).
*/
export const updatePropertyIfNeeded: <S extends Record<any, any>>(
  state: S,
  key: keyof S,
  value?: any
) => S = (state, key, value) => {
  if (state[key] !== value) {
    const clone = Object.assign({}, state);
    clone[key] = value;
    return clone;
  }
  // No changes
  return state;
};
